import _ from 'lodash';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './SongPromptMultiple.module.scss';
import classNames from 'classnames';
import roundRegistry from '../roundRegistry';
import posed from 'react-pose';
import {keysToSingleValue} from '../utils/objectFactory';
import {allPoses, wrongPoses} from '../gameHelpers';
import * as audioBundle from '../audioBundle';

const visiblePoses = [
    'prompt-multiple',
    'wrong-answer-multiple-pre',
    'right-answer-multiple',
];
const safeWrongPoses = _.difference(wrongPoses, visiblePoses);

const Container = posed.div({
    ...keysToSingleValue(visiblePoses, {
        x: '20em',
        staggerChildren: 100,
        transition: {
            ease: 'easeOut',
            duration: 1000,
        },
    }),
    ...keysToSingleValue(_.without(allPoses, ...visiblePoses, ...safeWrongPoses), {
        x: '100vw',
        delay: 500,
        staggerChildren: 100,
        staggerDirection: -1,
        transition: {
            ease: 'easeIn',
            duration: 1000,
        },
    }),
    ...keysToSingleValue(safeWrongPoses, {
        staggerChildren: 100,
        staggerDirection: -1,
    }),
});

const Answer = posed.div({
    ...keysToSingleValue(visiblePoses, {
        x: 0,
        transition: {
            ease: 'easeOut',
            duration: 1000,
        },
    }),
    ...keysToSingleValue(_.without(allPoses, ...visiblePoses, ...safeWrongPoses), {
        x: '100vw',
        transition: {
            ease: 'easeIn',
            duration: 500,
        },
    }),
    ...keysToSingleValue(safeWrongPoses, {
        x: props => (props.right ? 0 : '100vw'),
        transition: {
            ease: 'easeIn',
            duration: 500,
        },
    }),
});

const answerIconPoses = ['wrong-answer-multiple-pre', 'right-answer-multiple'];

const AnswerIcon = posed.div({
    ...keysToSingleValue(answerIconPoses, {
        scale: 1,
        opacity: 1,
        transition: {
            ease: 'easeIn',
            duration: 500,
        },
    }),
    ...keysToSingleValue(_.difference(allPoses, answerIconPoses), {
        scale: 10,
        opacity: 0,
        transition: {duration: 0},
    }),
});

export default class SongPromptMultiple extends Component {
    static propTypes = {
        game: PropTypes.object.isRequired,
        onRightAnswer: PropTypes.func.isRequired,
        onWrongAnswer: PropTypes.func.isRequired,
        onChangeGame: PropTypes.func.isRequired,
    };

    state = {
        selectedAnswerIndex: -1,
    };

    timers = [];

    addTimeout(fn, delay) {
        this.timers.push(setTimeout(fn, delay));
    }

    componentDidUpdate(prevProps) {
        if (prevProps.game.round !== this.props.game.round) {
            this.setState({
                selectedAnswerIndex: -1,
            });
        }
    }

    componentWillUnmount() {
        this.timers.forEach(clearTimeout);
    }

    render() {
        const {game} = this.props;
        const {answers} = roundRegistry[game.round];

        return (
            <Container className={styles.container}>
                <div className={styles.question}>Who is the artist?</div>
                {answers.map(this.renderAnswer)}
            </Container>
        );
    }

    renderAnswer = (answer, index) => {
        const {selectedAnswerIndex} = this.state;
        const {game} = this.props;
        const {rightAnswerIndex} = roundRegistry[game.round];

        const selected = index === selectedAnswerIndex;
        const right = index === rightAnswerIndex;
        const answerIconClassName = classNames({
            [styles.rightAnswerIcon]: right,
            [styles.wrongAnswerIcon]: !right,
        });

        return (
            <Answer
                key={index}
                right={right}
                className={styles.answer}
                onClick={this.selectAnswer(index)}
            >
                <div className={styles.circle}>
                    {selected && <AnswerIcon className={answerIconClassName} />}
                </div>
                <div className={styles.spacer} />
                <div className={styles.text}>{answer}</div>
            </Answer>
        );
    };

    selectAnswer = index => () => {
        const {game} = this.props;
        const {rightAnswerIndex} = roundRegistry[game.round];

        if (game.stage !== 'prompt-multiple') return;

        this.setState({
            selectedAnswerIndex: index,
        });

        if (index === rightAnswerIndex) {
            this.props.onRightAnswer();
        } else {
            audioBundle.play('wrong');

            this.props.onChangeGame({
                ...game,
                stage: 'wrong-answer-multiple-pre',
                correct: false,
            });

            this.addTimeout(this.props.onWrongAnswer, 2000);
        }
    };
}
